import { Inject, Injectable } from '@angular/core';
import { USE_STORE, USE_DEFAULT_LANG, USE_EXTEND, DEFAULT_LANGUAGE } from '@ngx-translate/core';
import { ILocalizationOptions, LOCALIZATION_OPTIONS } from '../models/i-localization-options';

@Injectable()
export class LocalizationOptionService {
  public constructor(
    @Inject(LOCALIZATION_OPTIONS) public readonly options: ILocalizationOptions,
    @Inject(USE_STORE) public readonly isolate: boolean,
    @Inject(USE_DEFAULT_LANG) public readonly useDefaultLang: boolean,
    @Inject(USE_EXTEND) public readonly extend: boolean,
    @Inject(DEFAULT_LANGUAGE) public readonly defaultLanguage: string,
  ) {}
}
